import React, { useState } from "react";
import AgentImg from "../../Images/ct.webp";
import API from "../../utils/api";

const Contact = () => {
  const [form, setForm] = useState({
    person: "",
    email: "",
    company: "",
    platform: "",
    phone: "",
    website: "",
    message: "",
    consent1: false,
    consent2: false,
  });

  const [status, setStatus] = useState({ loading: false, ok: null, msg: "" });

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!form.person.trim() || !form.email.trim()) {
      return setStatus({
        loading: false,
        ok: false,
        msg: "Bitte Ansprechpartner*in und E-mail ausfüllen.",
      });
    }

    // Optional: enforce consents
    if (!form.consent1 || !form.consent2) {
      return setStatus({
        loading: false,
        ok: false,
        msg: "Bitte beide Checkboxen bestätigen.",
      });
    }

    try {
      setStatus({ loading: true, ok: null, msg: "" });

      await API.post("contact2", {
        ...form,
        formName: "Analyse Kontaktformular",
      });

      setStatus({
        loading: false,
        ok: true,
        msg: "Danke! Wir melden uns in Kürze.",
      });

      setForm({
        person: "",
        email: "",
        company: "",
        platform: "",
        phone: "",
        website: "",
        message: "",
        consent1: false,
        consent2: false,
      });
    } catch (err) {
      console.error(err);
      setStatus({
        loading: false,
        ok: false,
        msg: "Senden fehlgeschlagen. Bitte später erneut versuchen.",
      });
    }
  };

  return (
    <section className="bg-white mt-32 w-[90%] 2xl:w-[70%] mx-auto rounded-2xl shadow-[0_20px_60px_-20px_rgba(0,0,0,0.15)] border border-[#cac6c6] overflow-hidden">
      <div className="mx-auto flex gap-8 overflow-hidden items-stretch">
        {/* LEFT */}
        <div className="py-10 w-[100%] md:w-[65%] pl-8 pr-8 md:pr-0 md:py-12 lg:py-14">
          <h2 className="h2-mb h2-md h2-lg h2-2xl">
            Bereit, loszulegen? Wir freuen <br className="hidden lg:block" />
            uns auf deine Nachricht!
          </h2>
          <p className="mt-4 text-base text-slate-600">
            Wir sind rund um die Uhr erreichbar.
          </p>

          {/* FORM */}
          <form className="mt-10" onSubmit={onSubmit}>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
              <Field
                icon={<UserIcon />}
                placeholder="Ansprechpartner*in"
                type="text"
                name="person"
                value={form.person}
                onChange={onChange}
              />
              <Field
                icon={<MailIcon />}
                placeholder="E-mail*"
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
              />

              <Field
                icon={<BuildingIcon />}
                placeholder="Firmenname"
                type="text"
                name="company"
                value={form.company}
                onChange={onChange}
              />

              <SelectField
                icon={<LinkIcon />}
                placeholder="Auswählen"
                name="platform"
                value={form.platform}
                onChange={onChange}
                options={[
                  "Google",
                  "Trustpilot",
                  "Facebook",
                  "Yelp",
                  "Apple Maps",
                  "Bing",
                  "Andere",
                ]}
              />

              <Field
                icon={<PhoneIcon />}
                placeholder="Telefon"
                type="tel"
                name="phone"
                value={form.phone}
                onChange={onChange}
              />
              <Field
                icon={<GlobeIcon />}
                placeholder="Webseite"
                type="url"
                name="website"
                value={form.website}
                onChange={onChange}
              />
            </div>

            {/* Nachricht */}
            <div className="relative mt-5">
              <div className="flex items-start gap-3 rounded-lg border border-[#cac6c6] bg-slate-50 px-4 py-3">
                <div className="mt-[2px] text-slate-500">
                  <MessageIcon />
                </div>
                <textarea
                  className="min-h-[120px] w-full resize-none bg-transparent text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none"
                  placeholder="Nachricht"
                  name="message"
                  value={form.message}
                  onChange={onChange}
                />
              </div>

              {/* WhatsApp button (kept as-is) */}
              <button
                type="button"
                className="absolute bottom-4 right-4 inline-flex items-center gap-2 rounded-full bg-emerald-600 px-4 py-2 text-sm font-medium text-white shadow-md shadow-emerald-600/20 hover:bg-[#8ec700]"
              >
                Kontakt via Whatsapp <WhatsAppIcon />
              </button>
            </div>

            {/* Consent */}
            <div className="mt-6 grid gap-3 md:grid-cols-2 md:gap-4">
              <label className="flex items-start gap-3 text-sm text-slate-600">
                <input
                  type="checkbox"
                  name="consent1"
                  checked={form.consent1}
                  onChange={onChange}
                  className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-600"
                />
                <span>
                  Sind Sie damit einverstanden, dass wir Ihre Daten zum Zwecke
                  der Anfrageabwicklung verarbeiten
                </span>
              </label>

              <label className="flex items-start gap-3 text-sm text-slate-600">
                <input
                  type="checkbox"
                  name="consent2"
                  checked={form.consent2}
                  onChange={onChange}
                  className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-600"
                />
                <span>
                  Mir ist bewusst, dass die UNEVA  keine Rechtsberatung
                  anbietet und keine inhaltliche Prüfung meiner Bewertung
                  erfolgt.
                </span>
              </label>
            </div>

            {/* CTA */}
            <div className="mt-6">
              <button
                type="submit"
                disabled={status.loading}
                className="flex items-center gap-3 my-8 px-4 py-3 rounded-xl border border-[#0b2b40] text-white text-[16px] hover:bg-[#051621] hover:-translate-y-1 transition-all duration-300 bg-[#0b2b40] disabled:opacity-60 disabled:hover:translate-y-0"
              >
                <span>
                  {status.loading
                    ? "Senden..."
                    : "Jetzt kostenlose Analyse starten"}
                </span>
              </button>

              {status.ok === true && (
                <p className="text-emerald-700 text-sm">{status.msg}</p>
              )}
              {status.ok === false && (
                <p className="text-red-600 text-sm">{status.msg}</p>
              )}
            </div>
          </form>

          {/* Contact Info (unchanged) */}
          <div className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-2">
            <InfoItem
              icon={<PhoneSolidIcon />}
              title="TELEFON"
              value="0421 36583008"
            />
            <InfoItem
              icon={<PinIcon />}
              title="ADRESSE"
              value="Gelsenkirchenerstr. 12, 28199 Bremen"
            />
            <InfoItem
              icon={<MailSolidIcon />}
              title="EMAIL"
              value="anfrage@uneva.de"
            />
            <InfoItem
              icon={<ClockIcon />}
              title="ÖFFNUNGSZEITEN"
              value="09:00 - 17:00 Uhr"
            />
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden md:block w-[35%] self-stretch">
          <img
            src={AgentImg}
            alt="Support Agent"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;

/* ---------- Small components (UPDATED to accept props) ---------- */

function Field({ icon, placeholder, type = "text", name, value, onChange }) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-[#cac6c6] bg-slate-50 px-4 py-3">
      <div className="text-slate-500">{icon}</div>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full bg-transparent text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none"
      />
    </div>
  );
}

function SelectField({
  icon,
  placeholder,
  options = [],
  name,
  value,
  onChange,
}) {
  return (
    <div className="group relative flex items-center gap-3 rounded-xl border border-[#cac6c6] bg-white px-4 py-3 shadow-sm transition hover:border-slate-300 hover:shadow-md focus-within:border-emerald-500 focus-within:ring-2 focus-within:ring-emerald-500/20">
      <div className="text-emerald-600 shrink-0">{icon}</div>

      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full appearance-none bg-transparent text-sm text-slate-800 focus:outline-none cursor-pointer"
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>

      <div className="pointer-events-none absolute right-4 text-slate-400 group-hover:text-slate-600">
        <ChevronDownIcon />
      </div>
    </div>
  );
}

/* InfoItem + icons are unchanged from your code */

function InfoItem({ icon, title, value }) {
  return (
    <div className="flex items-start gap-4">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-lime-200 text-slate-800">
        {icon}
      </div>
      <div>
        <div className="text-sm font800 font-semibold tracking-wide text-slate-900">
          {title}
        </div>
        <div className="mt-1 text-base text-slate-700">{value}</div>
      </div>
    </div>
  );
}

/* ---------- Icons (inline SVG) ---------- */

function UserIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 12a4.5 4.5 0 1 0-4.5-4.5A4.5 4.5 0 0 0 12 12Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M20 20.5c0-4-3.6-6.5-8-6.5s-8 2.5-8 6.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M6.5 7.5 12 12l5.5-4.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BuildingIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 20V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v14"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M3 20h18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9 8h2M9 12h2M9 16h2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function LinkIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M10.5 13.5 13.5 10.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M8 14a4 4 0 0 1 0-6l1.5-1.5a4 4 0 0 1 6 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M16 10a4 4 0 0 1 0 6L14.5 17.5a4 4 0 0 1-6 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 3h3l2 5-2 1.5c1.2 2.6 3 4.4 5.5 5.5L17 13l5 2v3c0 1.1-.9 2-2 2C10.6 20 4 13.4 4 5c0-1.1.9-2 2-2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 21a9 9 0 1 0-9-9 9 9 0 0 0 9 9Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M3 12h18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12 3c2.5 2.6 3.8 5.8 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.8-3.8-9S9.5 5.6 12 3Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}

function MessageIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H10l-4.5 4V16H6.5A2.5 2.5 0 0 1 4 13.5v-7Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      className="text-slate-500"
    >
      <path
        d="M7 10l5 5 5-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 32 32" fill="currentColor">
      <path d="M19.11 17.53c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.36.23-.66.08-.3-.15-1.27-.47-2.42-1.5-.89-.8-1.49-1.79-1.66-2.09-.18-.3-.02-.46.13-.61.13-.13.3-.36.45-.54.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.64-.93-2.25-.24-.58-.49-.5-.68-.5h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.71.64.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.41.25-.69.25-1.28.18-1.41-.08-.13-.28-.2-.58-.35z" />
      <path d="M26.67 5.33A13.19 13.19 0 0 0 16.02 1C8.47 1 2.33 7.14 2.33 14.69c0 2.42.63 4.78 1.83 6.86L2 31l9.62-2.52a13.64 13.64 0 0 0 4.4.72h.01c7.55 0 13.69-6.14 13.69-13.69 0-3.65-1.42-7.08-3.99-9.66zM16.03 27.1h-.01c-1.38 0-2.74-.25-4.01-.74l-.29-.11-5.71 1.5 1.53-5.56-.19-.29a11.38 11.38 0 0 1-1.78-6.18c0-6.28 5.11-11.39 11.4-11.39 3.04 0 5.9 1.18 8.05 3.33a11.32 11.32 0 0 1 3.33 8.06c0 6.28-5.11 11.39-11.39 11.39z" />
    </svg>
  );
}

function PhoneSolidIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M7.2 2.6h3.2l1.6 5-2.1 1.6c1.3 2.7 3.3 4.7 6 6l1.6-2.1 5 1.6v3.2c0 1.1-.9 2-2 2C10 20.9 3.1 14 3.1 4.6c0-1.1.9-2 2-2z" />
    </svg>
  );
}

function MailSolidIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 6H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-.7 2L12 13 4.7 8h14.6z" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 11h5v-2h-4V6h-2v7z" />
    </svg>
  );
}
